var _module_exports = "<div class=\"row header\">\n  <div id=\"loadingbar-placeholder\"></div>\n  <div class=\"col-xs-12\"> <div class=\"meta\" ng-transclude></div></div>\n</div>\n";;
var path = 'app/portainer/components/PageHeader/HeaderContainer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;